import type { FC, ReactElement } from 'react';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { CheckCircle } from '@eqi-investimentos/icons/web';
import { Button, Text, Flex } from '@eqi-investimentos/react';
import { ListIcon, ListItem, UnorderedList } from '@chakra-ui/react';
import { Drawer, type DrawerProps } from '../Drawer';
export const OpenAccountDrawer: FC<OpenAccountDrawerProps> = ({
  screen,
  customButton,
  handleBeforeDrawerOpen
}) => {
  const {
    t
  } = useTranslation('common');
  const advantages = Array.from({
    length: 3
  }).map((_, i) => t(`drawers.openAccount.advantages.list.${i}`));
  return <Drawer id="open-account-drawer" handleBeforeDrawerOpen={handleBeforeDrawerOpen} showIconButton={false} showCustomButton headerContent={<Text size="xl" color="content.primary">
          {t('drawers.openAccount.header')}
        </Text>} customButton={customButton || <Button size="lg">{t('attributes.openAccount')}</Button>} bodyProps={{
    display: 'flex',
    flexDir: 'column',
    px: '2xl',
    pb: '5xl',
    gap: '2xl',
    sx: {
      '#qr-code': {
        alignSelf: 'center'
      }
    }
  }} headerProps={{
    pl: '3.75rem'
  }} backButtonProps={{
    buttonProps: {
      top: '2.25rem'
    }
  }} data-sentry-element="Drawer" data-sentry-component="OpenAccountDrawer" data-sentry-source-file="index.tsx">
      <Flex gap="l" flexDir="column" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Image src="/assets/eqi-logo.svg" alt="Logo quadrado com fundo laranja com a sigla EQI em preto" width={50} height={50} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        <Flex gap="s" flexDir="column" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <Text size="h5" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
            {t('drawers.openAccount.title')}
          </Text>
          <Text size="xl" color="content.secondary" dangerouslySetInnerHTML={{
          __html: t('drawers.openAccount.description')
        }} sx={{
          '&>b': {
            color: 'content.primary'
          }
        }} data-sentry-element="Text" data-sentry-source-file="index.tsx" />{' '}
        </Flex>
      </Flex>
      <Image id="qr-code" src={qrCodeByScreen[screen]} alt="QR Code para download do aplicativo" width={208} height={208} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      <Text size="2xl" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
        {t('drawers.openAccount.advantages.title')}
      </Text>
      <UnorderedList spacing={5} listStyleType="none" justifyContent="flex-start" m={0} data-sentry-element="UnorderedList" data-sentry-source-file="index.tsx">
        {advantages.map(advantage => <ListItem key={advantage} display="flex" alignItems="center">
            <ListIcon as={CheckCircle} h={24} w={24} color="alert.success" />
            <Text size="xl" color="content.secondary">
              {advantage}
            </Text>
          </ListItem>)}
      </UnorderedList>
    </Drawer>;
};
type OpenAccountDrawerProps = Pick<DrawerProps, 'handleBeforeDrawerOpen'> & {
  screen: keyof typeof qrCodeByScreen;
  customButton?: ReactElement;
};
const qrCodeByScreen = {
  business: '/assets/qr-codes/qr-code-business.svg',
  exchange: '/assets/qr-codes/qr-code-exchange.svg',
  goodsAcquisition: '/assets/qr-codes/qr-code-goods-acquisition.svg',
  invest: '/assets/qr-codes/qr-code-invest.svg',
  lifeInsurance: '/assets/qr-codes/qr-code-life-insurance.svg',
  news: '/assets/qr-codes/qr-code-news.svg',
  prev: '/assets/qr-codes/qr-code-prev.svg',
  research: '/assets/qr-codes/qr-code-research.svg',
  rvAdvisory: '/assets/qr-codes/qr-code-rv-advisory.svg'
} as const;